import { useState } from 'react'
import { DailySummary } from '../../presentationals/DailySummary'

interface DailySummaryContainerProps{
    summary: any
    spyId?: number
    onModeChange: (event: any) => void
    onDateChange: (event: any) => void
    onDateSelectOpenChange: (event: any) => void
}

export const DailySummaryContainer = (props: DailySummaryContainerProps): JSX.Element => {
    const {
        summary,
        spyId,
        onModeChange,
        onDateSelectOpenChange
    } = props

    const handleModeChange = (event: any) => {
        onModeChange?.(event)
    }

    const handleDateChange = (event: any) => {

    }

    const handleDailySummaryDateSelectOpenChange = (event: any) => {
        onDateSelectOpenChange?.(event)
    }

    return (
       <DailySummary 
            summary={summary}
            onModeChange={handleModeChange}
            onDateChange={handleDateChange}
            onDateSelectOpenChange={handleDailySummaryDateSelectOpenChange}
       /> 
    )
}